var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-text-field',{attrs:{"label":"Request data","error":_vm.requestInvalid},model:{value:(_vm.rawRequest),callback:function ($$v) {_vm.rawRequest=$$v},expression:"rawRequest"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }